/* eslint-disable object-shorthand */
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './dropDownMenu.module.scss';
import '../../constants/_global.scss';
import { DropDowMenuInterface } from './dropDownMenuTypes';
import { ReactComponent as Arrow } from '../../assets/arrow.svg';

const DropDownMenu: React.FC<DropDowMenuInterface> = ({
  options,
  disabled,
  name,
  onChange,
  customWidth,
  isMobile,
}) => {
  const [isDropped, setIsDropped] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string>('Опция');
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1000 });
  const mobileVer = isMobile ? styles.optionsMobile : styles.options;

  useEffect(() => {
    setSelectedOption(options[0]);
  }, [options]);

  const arrowClick = () => {
    setIsDropped(!isDropped);
  };

  const handleClick = (option: string) => {
    setSelectedOption(option);
    setIsDropped(false);
    if (onChange) {
      const event = {
        target: { value: option, name: name } as HTMLInputElement,
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(event);
    }
  };

  const mainWidth = {
    margin: '0',
    maxWidth: customWidth ? `${customWidth}px` : '250px',
    width: '100%',
  };

  return (
    <div className={styles.dropMenu} style={mainWidth}>
      <div
        className={disabled ? styles.disabled : styles.input}
        style={mainWidth}
      >
        <input
          readOnly
          type="text"
          value={selectedOption}
          className={`${styles.noDefault} spanGlobal`}
          style={mainWidth}
          disabled={disabled}
          name={name}
        />
        <button
          className={
            isDropped
              ? `${styles.arrowUp} ${styles.noDefault}`
              : `${styles.arrowDown} ${styles.noDefault}`
          }
          type="button"
          onClick={arrowClick}
          disabled={disabled}
        >
          <Arrow />
        </button>
      </div>
      <div
        className={isDropped ? mobileVer : styles.hidden}
        style={{ backgroundColor: isTabletOrMobile ? 'white' : 'transparent' }}
      >
        {options.map((option) => (
          <button
            className={`${styles.btn} ${styles.noDefault}`}
            type="button"
            onClick={() => handleClick(option)}
          >
            <span className={`${styles.spanGlobal} ${styles.textColor}`}>
              {option}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DropDownMenu;
